<template>
  <div>
    <search-list
    @findData="findData" class="mb8"></search-list>
    <div class="page-wrapper">
      <table-list
        :columns="columns"
        :defaultColumns ="defaultColumns"
        :data="tableData"
        :total="total"
        :current="current"
        :loading="loading"
        @change-page="changePage"
      >
      </table-list>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SearchList from './components/SearchList'
import TableList from "components/FilterTableList/index";
// import TableList from 'components/TableList/index';
import {getProjects } from 'api/common'
import { getConditions, getList} from 'api/auditContract'
export default {
  name:'auditcontract',
  components:{
    SearchList,
    TableList
  },
  created(){
    this.findData(this.searchData)
  },
  data () {
    return {
      total:0,
      current:1,
      loading:false,
      searchData:{
        projectFid:'',
        contractState:'',
        rentType:'',
        contractType:'',
        isRenew:'',
        source:'',
        deliveryState:'',
        signEndDate:'',
        signStartDate:'',
        expireStartDate:'',
        expireEndDate:'',
        stockNumber:'',
        limit: 10,
        page: 1
      },
      projectList:[],
      columns:[
        {
          type: 'index',
          align: 'center',
          width: 60
        },
        {
          title: '项目',
          key: 'projectName',
          align: 'center',
          width:160
        },
        {
          title: '房间/床位号',
          key: 'stockNumber',
          align: 'center',
          width:120
        },
        {
          title: '合同编号',
          key: 'contractCode',
          align: 'center',
          width:160
        },
        {
          title: '租约类型',
          key: 'rentTypeName',
          align: 'center',
          width:100
        },
        {
          title: '合同状态',
          key: 'contractStateName',
          align: 'center',
          width:100
        },
        {
          title: '交割状态',
          key: 'deliveryStateName',
          align: 'center',
          width:100
        },
        {
          title: '审核状态',
          key: 'auditStateName',
          align: 'center',
          width:100
        },
        {
          title: '签约客户',
          key: 'signName',
          align: 'center',
          width:220
        },
        {
          title: '签约手机号',
          key: 'userPhone',
          align: 'center',
          width:120
        },
        {
          title: '起租日',
          key: 'conStartDate',
          align: 'center',
          width:120
        },
        {
          title: '到期日',
          key: 'conEndDate',
          align: 'center',
          width:120
        },
         {
          title: '操作',
          key: 'action',
          align: 'center',
          fixed:'right',
          width:150,
          render:(h,params)=>{
            return h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    menu:'auditcontract',
                    api:'enterprisecontract/confirmAudit'
                  }
                }
              ],
              style: {
                color:'#CFA868',
                display:params.row.subjectType === 1 || params.row.auditState == 1?'none':'inline-block'
              },
              on:{
                click:()=>{
               if (params.row.subjectType === 3){
                  this.$router.push({
                    name: 'companycontractdetail',
                    query:{
                      isaudit:1,
                      isParent:1,
                      pid:params.row.parentContractFid,
                      id:params.row.fid,
                      code:params.row.contractCode
                    }
                  })
                  }
                }
              }
            },'审核')

          }
        },
      ],
      defaultColumns:['projectName','stockNumber', 'contractCode', 'rentTypeName', 'contractStateName', 'deliveryStateName', 'auditStateName', 'signName', 'userPhone', 'conStartDate','conEndDate','action' ],
      tableData:[]
    };
  },
  watch: {
    $route(to, from) {
     if(from.name=='companycontractdetail'&&from.query.isaudit==1){
      this.findData(this.searchData)
     }
    }
  },
  methods: {
    changePage(n){
      this.loading  = true;
      this.current = n;
      this.searchData.page = n;
      this.getList(this.searchData)
    },
    getList(data){
      this.loading = true;
      getList(data).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.loading = false
      })
    },
    findData(data){
      this.current = 1;
      this.searchData = data;
      this.searchData.page = 1;
      this.getList(this.searchData)

    }
  }
}
</script>
